import React from "react";
import { Hand, MessagesSquare, UserRound, Zap } from "lucide-react";

// AUTO-WA-39: shown before a chat is picked — a short orientation for new users.
function ChatEmpty() {
  const tips = [
    { icon: MessagesSquare, text: "Pick a chat on the left to read and reply." },
    { icon: UserRound, text: "Use Mine and Unassigned to share work with your team." },
    { icon: Zap, text: "Save answers you repeat as quick replies." },
    { icon: Hand, text: "If a bot is answering, you can take over any time." },
  ];
  return (
    <main className="wa-chat-empty">
      <div className="wa-chat-empty-card">
        <span className="wa-chat-empty-icon" aria-hidden="true"><MessagesSquare size={24} /></span>
        <h2>Choose a chat</h2>
        <p>Every WhatsApp message to your business number lands here.</p>
        <ul>
          {tips.map(({ icon: Icon, text }) => <li key={text}><Icon size={15} aria-hidden="true" />{text}</li>)}
        </ul>
      </div>
    </main>
  );
}

export default ChatEmpty;
